var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAssignments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 3h14v15l-3 3H5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#545454",
    d: "M14 16h5v2l-3 3h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 8c-1.778 2.037-3.207 4.37-4.286 7L9 12"
  }))));
}

export default "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E %3Cg fill='none' fill-rule='evenodd' stroke-width='2'%3E %3Cpath stroke-linejoin='round' stroke-width='2' d='M0 0L14 0 14 15 11 18 0 18z' transform='translate(5 3)'/%3E %3Cpath fill='%23545454' d='M9 13L14 13 14 15 11 18 9 18z' transform='translate(5 3)'/%3E %3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M10 5c-1.778 2.037-3.207 4.37-4.286 7L4 9' transform='translate(5 3)'/%3E %3C/g%3E %3C/svg%3E";
export { SvgAssignments as ReactComponent };